module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section-header with-border"
  }, [_vm._v("\n\t\t\t\t设置\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "展示图"
    }
  }, _vm._l((_vm.t_data.data), function(item, index) {
    return _c('div', {
      staticClass: "setting-item slider"
    }, [(!_vm.num) ? _c('div', {
      staticClass: "setting-remove",
      on: {
        "click": function($event) {
          return _vm.removeItem(index)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-trash-alt"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      on: {
        "click": function($event) {
          return _vm.handleImgChange(index)
        }
      }
    }, [(item.imgUrl) ? _c('img', {
      staticClass: "banner-uploader",
      attrs: {
        "src": item.imgUrl
      }
    }) : _c('div', {
      staticClass: "banner-uploader"
    }, [_c('i', {
      staticClass: "iconfont icon-camera"
    }), _vm._v("\n\t\t\t\t\t\t\t上传图片\n\t\t\t\t\t\t")])]), _vm._v(" "), (_vm.show_goods) ? _c('div', {
      staticClass: "uploader-setting"
    }, [_c('div', {
      staticClass: "goods-select",
      on: {
        "click": function($event) {
          return _vm.handleGoodsChange(index)
        }
      }
    }, [(item.goodsId) ? _c('div', {
      staticClass: "link-content"
    }, [
      [_vm._v("商品：")], _vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.title) + "\n\t\t\t\t\t\t\t")
    ], 2) : _c('div', {
      staticClass: "content-center"
    }, [_c('i', {
      staticClass: "iconfont icon-link",
      on: {
        "click": function($event) {
          return _vm.handleGoodsChange(index)
        }
      }
    }), _vm._v("设置路径")])])]) : _vm._e()])
  }), 0)], 1), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgsVisible,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeimgsVisible
    }
  }), _vm._v(" "), _c('goodsPicker', {
    attrs: {
      "usage": "pc",
      "visible": _vm.goodsVisible
    },
    on: {
      "pickGoods": _vm.pickGoods,
      "closeDialog": _vm.closeDialog
    }
  })], 1), _vm._v(" "), (!_vm.num || (_vm.num && _vm.t_data.data.length < 4)) ? _c('div', {
    staticClass: "content-center"
  }, [_c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("只能上传jpg/png文件（建议尺寸：1220px * 500px）")]), _vm._v(" "), _c('el-button', {
    staticClass: "iconfont icon-plus-circle banner-button-uploader",
    attrs: {
      "disabled": _vm.data.length >= 5,
      "type": "default"
    },
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v(" " + _vm._s(_vm.text))])], 1) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-08b3a78c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08b3a78c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/pc/custompage/pluginscomponents/ProductMap.vue
// module id = 2449
// module chunks = 0